// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NsuQ","col":"styles_col__2Wfyl"};